import { setupReceiptProcessingTrackingListener } from 'app-components/store/listeners';

import { startAppListening } from '../listenerMiddleware';

setupReceiptProcessingTrackingListener(startAppListening);
